(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["huesha-cinema-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.hhInit === '1') return;
      root.dataset.hhInit = '1';

      var slides = root.querySelectorAll('.hh__slide');
      var thumbs = root.querySelectorAll('.hh__thumb');
      var labels = root.querySelectorAll('.hh__label');
      var bar = root.querySelector('.hh__bar');
      var counter = root.querySelector('[data-current]');
      var interval = parseInt(root.dataset.interval, 10) || 5200;
      var autoplay = root.dataset.autoplay === 'true' && slides.length > 1;
      var i = 0, timer = null, paused = false;

      root.style.setProperty('--hh-interval', interval + 'ms');

      function pad(n) { return n < 10 ? '0' + n : String(n); }

      function show(n) {
        i = ((n % slides.length) + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.setAttribute('data-active', k === i ? 'true' : 'false'); });
        thumbs.forEach(function (t, k) { k === i ? t.setAttribute('data-active', 'true') : t.removeAttribute('data-active'); });
        labels.forEach(function (l, k) { l.hidden = k !== i; });
        if (counter) counter.textContent = pad(i + 1);
        root.querySelectorAll('.hh-rise').forEach(function (el) {
          el.style.animation = 'none'; void el.offsetWidth; el.style.animation = '';
        });
        if (bar) { bar.classList.remove('is-run'); void bar.offsetWidth; if (autoplay && !paused) bar.classList.add('is-run'); }
      }

      function start() { if (!autoplay) return; stop(); timer = setInterval(function () { show(i + 1); }, interval); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { show(parseInt(t.dataset.go, 10)); start(); });
      });

      root.addEventListener('mouseenter', function () { paused = true; stop(); if (bar) bar.classList.remove('is-run'); });
      root.addEventListener('mouseleave', function () { paused = false; show(i); start(); });

      show(0);
      start();
    }

    function boot() { document.querySelectorAll('.hh').forEach(init); }
    document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('.hh')); });
    boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["huesha-pdp-results"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.huesha-results [data-huesha-ba]').forEach(function (ba) {
      var wrap   = ba.querySelector('.huesha-ba__wrap');
      var before = ba.querySelector('[data-huesha-ba-before]');
      var handle = ba.querySelector('[data-huesha-ba-handle]');
      var range  = ba.querySelector('[data-huesha-ba-range]');
      if (!wrap || !before || !handle) return;
      wrap.querySelectorAll('img').forEach(function (img) { img.setAttribute('draggable', 'false'); });
      function setBA(v) {
        v = Math.max(0, Math.min(100, v));
        var clip = 'inset(0 ' + (100 - v) + '% 0 0)';
        before.style.clipPath = clip;
        before.style.webkitClipPath = clip;
        handle.style.left = v + '%';
        if (range) range.value = v;
      }
      function fromEvent(e) {
        var rect = wrap.getBoundingClientRect();
        var x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
        setBA((x / rect.width) * 100);
      }
      var dragging = false;
      function start(e) { dragging = true; fromEvent(e); e.preventDefault(); }
      function move(e)  { if (dragging) fromEvent(e); }
      function end()    { dragging = false; }
      wrap.addEventListener('mousedown', start);
      window.addEventListener('mousemove', move);
      window.addEventListener('mouseup', end);
      wrap.addEventListener('touchstart', start, { passive: false });
      window.addEventListener('touchmove', move, { passive: false });
      window.addEventListener('touchend', end);
      wrap.addEventListener('dragstart', function (e) { e.preventDefault(); });
      if (range) range.addEventListener('input', function (e) { setBA(e.target.value); });
      setBA(50);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["huesha-pdp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-hue-pdp]').forEach(function (root) {
      // Galeri
      var main = root.querySelector('[data-hue-main]');
      var thumbs = root.querySelectorAll('[data-hue-thumb]');
      var dots = root.querySelectorAll('[data-hue-dot]');
      function selectImage(i) {
        var t = root.querySelector('[data-hue-thumb="' + i + '"]');
        if (!t || !main) return;
        main.src = t.getAttribute('data-src');
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        dots.forEach(function (d) { d.classList.toggle('is-active', d.getAttribute('data-hue-dot') === String(i)); });
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { selectImage(t.getAttribute('data-hue-thumb')); }); });
      dots.forEach(function (d) { d.addEventListener('click', function () { selectImage(d.getAttribute('data-hue-dot')); }); });

      // Miktar
      var qtyInput = root.querySelector('[data-hue-qty-input]');
      root.querySelectorAll('[data-hue-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!qtyInput) return;
          var v = parseInt(qtyInput.value || '1', 10) + parseInt(b.getAttribute('data-hue-qty'), 10);
          qtyInput.value = Math.max(1, v);
        });
      });

      // Variant sync
      var optionSelects = root.querySelectorAll('[data-hue-option-index]');
      var idSelect = root.querySelector('[data-hue-id]');
      var priceNow = root.querySelector('.hue-pdp__price-now');
      var priceWas = root.querySelector('.hue-pdp__price-was');
      var stickyPrice = document.querySelector('[data-hue-sticky-price]');
      function syncVariant() {
        if (!idSelect) return;
        var picked = [];
        optionSelects.forEach(function (s) { picked.push(s.value); });
        var match = null;
        Array.prototype.forEach.call(idSelect.options, function (o) {
          if (o.text.replace(/\s+/g,'') === picked.join('/').replace(/\s+/g,'')) match = o;
        });
        if (!match && optionSelects.length === 0) match = idSelect.options[0];
        if (match) {
          idSelect.value = match.value;
          var pNow = match.getAttribute('data-price');
          if (priceNow && pNow) priceNow.textContent = pNow;
          if (stickyPrice && pNow) stickyPrice.textContent = pNow;
          if (priceWas) {
            var cmp = match.getAttribute('data-compare');
            priceWas.style.display = (cmp && cmp !== pNow) ? '' : 'none';
            if (cmp) priceWas.textContent = cmp;
          }
        }
      }
      optionSelects.forEach(function (s) { s.addEventListener('change', syncVariant); });

      // Hemen Satın Al → AJAX add + checkout
      var form = root.querySelector('[data-hue-form]');
      var buyNow = root.querySelector('[data-hue-buynow]');
      if (buyNow && form) {
        buyNow.addEventListener('click', function (e) {
          e.preventDefault();
          var win = window.open('about:blank', '_blank');
          var data = new FormData(form);
          fetch('/cart/add.js', { method: 'POST', body: data, headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
            .then(function () { if (win) win.location.replace('/checkout'); else window.location.href = '/checkout'; })
            .catch(function () { if (win) win.close(); alert('Bir hata oluştu.'); });
        });
      }

      // Sticky CTA: ana CTA görünürlükten çıkınca göster (sadece mobil)
      var sticky = document.querySelector('[data-hue-sticky]');
      var addBtn = root.querySelector('[data-hue-add]');
      var ctaWrap = root.querySelector('.hue-pdp__cta');
      if (sticky && ctaWrap && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          var isMobile = window.matchMedia('(max-width: 768px)').matches;
          sticky.hidden = !(isMobile && !entries[0].isIntersecting);
        }, { threshold: 0 });
        io.observe(ctaWrap);
        window.addEventListener('resize', function () {
          if (!window.matchMedia('(max-width: 768px)').matches) sticky.hidden = true;
        });
      }
      // Sticky → Sepete Ekle (aynı formu submit eder)
      var stickyAdd = sticky ? sticky.querySelector('[data-hue-sticky-add]') : null;
      if (stickyAdd && addBtn) {
        stickyAdd.addEventListener('click', function () { addBtn.click(); });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["huesha-product-detail"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      document.querySelectorAll('.huesha-pd').forEach(function (root) {
        if (root.dataset.hueshaPdInit === '1') return;
        root.dataset.hueshaPdInit = '1';

        var main = root.querySelector('[data-huesha-pd-main]');
        var stage = root.querySelector('[data-huesha-pd-stage]');
        var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-huesha-pd-thumb]'));
        var dots = Array.prototype.slice.call(root.querySelectorAll('[data-huesha-pd-dot]'));
        var srcs = thumbs.map(function (t) { return t.getAttribute('data-src'); });
        var current = 0;

        var track = root.querySelector('[data-huesha-pd-track]');
        var slides = Array.prototype.slice.call(root.querySelectorAll('[data-huesha-pd-slide]'));
        var count = slides.length || srcs.length;

        function setTransform(px, animate) {
          if (!track) return;
          track.classList.toggle('is-animating', !!animate);
          track.style.transform = 'translate3d(' + px + 'px,0,0)';
        }
        function slideWidth() {
          return stage ? stage.clientWidth : 0;
        }
        function goTo(i, animate) {
          if (!count) return;
          i = Math.max(0, Math.min(count - 1, i));
          current = i;
          setTransform(-i * slideWidth(), animate !== false);
          if (main && srcs[i]) { /* keep lightbox source in sync */ }
          thumbs.forEach(function (x, idx) { x.classList.toggle('is-active', idx === i); });
          dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
          var activeThumb = thumbs[i];
          if (activeThumb && activeThumb.scrollIntoView) {
            activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          }
        }
        function selectImage(i) {
          if (!count) return;
          goTo(((i % count) + count) % count, true);
        }
        if (track) {
          setTransform(0, false);
          window.addEventListener('resize', function () { setTransform(-current * slideWidth(), false); });
        }

        thumbs.forEach(function (t, idx) {
          t.addEventListener('click', function (e) { e.preventDefault(); selectImage(idx); });
        });
        dots.forEach(function (d, idx) {
          d.addEventListener('click', function (e) { e.preventDefault(); selectImage(idx); });
        });

        var prev = root.querySelector('[data-huesha-pd-prev]');
        var next = root.querySelector('[data-huesha-pd-next]');
        if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); selectImage(current - 1); });
        if (next) next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); selectImage(current + 1); });

        // Parmakla birlikte sürüklenen galeri
        var dragMoved = false;
        if (stage && track && count > 1) {
          var startX = 0, startY = 0, startT = 0, lastX = 0, lastT = 0;
          var dragging = false, decided = false, horizontal = false, baseOffset = 0;

          function pointOf(e) {
            if (e.touches && e.touches[0]) return e.touches[0];
            if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0];
            return e;
          }
          function onStart(e) {
            var p = pointOf(e);
            dragging = true; decided = false; horizontal = false; dragMoved = false;
            startX = lastX = p.clientX; startY = p.clientY;
            startT = lastT = Date.now();
            baseOffset = -current * slideWidth();
            track.classList.remove('is-animating');
          }
          function onMove(e) {
            if (!dragging) return;
            var p = pointOf(e);
            var dx = p.clientX - startX;
            var dy = p.clientY - startY;
            if (!decided) {
              if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
              decided = true;
              horizontal = Math.abs(dx) > Math.abs(dy);
              if (!horizontal) { dragging = false; return; }
            }
            if (!horizontal) return;
            if (e.cancelable) e.preventDefault();
            dragMoved = true;
            lastX = p.clientX; lastT = Date.now();
            var offset = baseOffset + dx;
            var min = -(count - 1) * slideWidth();
            if (offset > 0) offset = offset * 0.35;
            else if (offset < min) offset = min + (offset - min) * 0.35;
            setTransform(offset, false);
          }
          function onEnd(e) {
            if (!dragging) { return; }
            dragging = false;
            if (!horizontal) return;
            var p = pointOf(e);
            var dx = p.clientX - startX;
            var dt = Math.max(1, Date.now() - startT);
            var velocity = (p.clientX - lastX) / Math.max(1, Date.now() - lastT) || dx / dt;
            var w = slideWidth() || 1;
            var target = current;
            if (Math.abs(dx) > w * 0.18 || Math.abs(dx / dt) > 0.45) {
              target = current + (dx < 0 ? 1 : -1);
            }
            goTo(target, true);
            setTimeout(function () { dragMoved = false; }, 60);
          }

          stage.addEventListener('touchstart', onStart, { passive: true });
          stage.addEventListener('touchmove', onMove, { passive: false });
          stage.addEventListener('touchend', onEnd, { passive: true });
          stage.addEventListener('touchcancel', onEnd, { passive: true });

          stage.addEventListener('mousedown', function (e) {
            if (e.button !== 0) return;
            e.preventDefault();
            onStart(e);
            function mm(ev) { onMove(ev); }
            function mu(ev) {
              document.removeEventListener('mousemove', mm);
              document.removeEventListener('mouseup', mu);
              onEnd(ev);
            }
            document.addEventListener('mousemove', mm);
            document.addEventListener('mouseup', mu);
          });
        }

        // Lightbox
        var lb = root.querySelector('[data-huesha-pd-lightbox]');
        var lbImg = root.querySelector('[data-huesha-pd-lb-img]');
        var lbClose = root.querySelector('[data-huesha-pd-lb-close]');
        var lbPrev = root.querySelector('[data-huesha-pd-lb-prev]');
        var lbNext = root.querySelector('[data-huesha-pd-lb-next]');

        function currentSrc(i) {
          if (srcs[i]) return srcs[i];
          var slideImg = slides[i] ? slides[i].querySelector('img') : null;
          return slideImg ? slideImg.currentSrc || slideImg.src : (main ? main.src : '');
        }
        function openLb(i) {
          if (!lb || !lbImg) return;
          if (typeof i !== 'number') i = current;
          var total = count || srcs.length;
          if (total) {
            current = ((i % total) + total) % total;
            lbImg.src = currentSrc(current);
            goTo(current, false);
          } else if (main) {
            lbImg.src = main.src;
          }
          lb.removeAttribute('hidden');
          document.documentElement.style.overflow = 'hidden';
          thumbs.forEach(function (x, idx) { x.classList.toggle('is-active', idx === current); });
          dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === current); });
        }
        function closeLb() {
          if (!lb) return;
          lb.setAttribute('hidden', '');
          document.documentElement.style.overflow = '';
        }
        function stepLb(delta) {
          var total = count || srcs.length;
          if (!total) return;
          current = ((current + delta) % total + total) % total;
          openLb(current);
        }

        if (stage && lb) {
          stage.style.cursor = 'zoom-in';
          stage.addEventListener('click', function (e) {
            if (dragMoved) return;
            if (e.target.closest && e.target.closest('button')) return;
            openLb(current);
          });
        }
        if (lbClose) lbClose.addEventListener('click', closeLb);
        if (lbPrev) lbPrev.addEventListener('click', function (e) { e.stopPropagation(); stepLb(-1); });
        if (lbNext) lbNext.addEventListener('click', function (e) { e.stopPropagation(); stepLb(1); });
        if (lb) {
          lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
        }
        document.addEventListener('keydown', function (e) {
          if (lb && !lb.hasAttribute('hidden')) {
            if (e.key === 'Escape') closeLb();
            if (e.key === 'ArrowLeft') stepLb(-1);
            if (e.key === 'ArrowRight') stepLb(1);
          }
        });

        // Product form blocks
        root.querySelectorAll('[data-huesha-pd-form]').forEach(function (form) {
          if (form.dataset.hueshaPdFormInit === '1') return;
          form.dataset.hueshaPdFormInit = '1';

          var variantsEl = form.querySelector('[data-huesha-pd-variants]');
          var idSelect = form.querySelector('[data-huesha-pd-id]');
          var optionInputs = Array.prototype.slice.call(form.querySelectorAll('[data-huesha-pd-option-index]'));
          var qtyInput = form.querySelector('[data-huesha-pd-qty-input]');
          var addButton = form.querySelector('[data-huesha-pd-add]');
          var variants = [];
          try { variants = variantsEl ? JSON.parse(variantsEl.textContent || '[]') : []; } catch (err) { variants = []; }

          function selectedOptions() {
            return optionInputs.map(function (input) { return input.value; });
          }
          function findVariant() {
            var selected = selectedOptions();
            return variants.find(function (variant) {
              return selected.every(function (value, idx) { return variant.options && variant.options[idx] === value; });
            });
          }
          function setButtonState(variant) {
            if (!addButton) return;
            var label = addButton.querySelector('span');
            var isAvailable = !!(variant && variant.available);
            addButton.disabled = !isAvailable;
            if (label) label.textContent = isAvailable ? (addButton.dataset.label || 'Sepete Ekle') : (addButton.dataset.soldLabel || 'Stokta Yok');
          }
          function syncVariant() {
            var variant = findVariant();
            if (variant && idSelect) idSelect.value = String(variant.id);
            setButtonState(variant || (idSelect && idSelect.selectedOptions[0] ? { available: idSelect.selectedOptions[0].dataset.available === 'true' } : null));
          }
          optionInputs.forEach(function (input) { input.addEventListener('change', syncVariant); });
          syncVariant();

          form.querySelectorAll('[data-huesha-pd-qty]').forEach(function (btn) {
            btn.addEventListener('click', function () {
              if (!qtyInput) return;
              var next = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + (parseInt(btn.dataset.hueshaPdQty, 10) || 0));
              qtyInput.value = String(next);
            });
          });

          form.addEventListener('submit', function (e) {
            if (!addButton) return;
            e.preventDefault();
            addButton.disabled = true;
            var label = addButton.querySelector('span');
            var original = addButton.dataset.label || (label ? label.textContent : 'Sepete Ekle');
            if (label) label.textContent = 'Ekleniyor...';

            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
              body: new FormData(form)
            })
              .then(function (res) { if (!res.ok) throw new Error('cart_add_failed'); return res.json(); })
              .then(function () {
                if (label) label.textContent = addButton.dataset.addedLabel || 'Sepete Eklendi';
                document.dispatchEvent(new CustomEvent('cart:refresh'));
                document.dispatchEvent(new CustomEvent('cart:updated'));
                if (addButton.dataset.openCart === 'true') {
                  var opened = false;
                  var drawer = document.querySelector('cart-drawer');
                  var notification = document.querySelector('cart-notification');
                  if (drawer && typeof drawer.open === 'function') { drawer.open(); opened = true; }
                  else if (notification && typeof notification.open === 'function') { notification.open(); opened = true; }
                  if (!opened && drawer) {
                    drawer.classList.add('active','is-open','animate','open');
                    drawer.removeAttribute('hidden');
                    document.body.classList.add('overflow-hidden');
                    opened = true;
                  }
                  if (!opened) {
                    var trigger = document.querySelector('[aria-controls="cart-drawer"], a[href$="/cart"], .header__icon--cart, #cart-icon-bubble, .js-cart-drawer-open, [data-cart-drawer-toggle]');
                    if (trigger) { trigger.click(); opened = true; }
                  }
                  if (!opened) { window.location.href = '{{ routes.cart_url }}'; }
                }
                window.setTimeout(function () { if (label) label.textContent = original; syncVariant(); }, 1800);
              })
              .catch(function () {
                if (label) label.textContent = 'Tekrar Dene';
                window.setTimeout(function () { if (label) label.textContent = original; syncVariant(); }, 1800);
              });
          });
        });

        // Hemen Satın Al: sepete ekle + checkout'a yönlendir
        root.querySelectorAll('[data-huesha-pd-buynow]').forEach(function (btn) {
          if (btn.dataset.hueshaPdBuynowInit === '1') return;
          btn.dataset.hueshaPdBuynowInit = '1';
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            var form = btn.closest('form') || root.querySelector('[data-huesha-pd-form]');
            if (!form) { window.location.href = '/checkout'; return; }
            var win = window.open('about:blank', '_blank');
            var data = new FormData(form);
            fetch('/cart/add.js', { method: 'POST', body: data, headers: { 'Accept': 'application/json' } })
              .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
              .then(function () { if (win) win.location.replace('/checkout'); else window.location.href = '/checkout'; })
              .catch(function () { if (win) win.close(); alert('Bir hata oluştu.'); });
          });
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
